import { useGetCommissionQuery } from "api/TenantSlug/Commission/hooks.ts";
import { ManageCommissionForm } from "components/Forms/ManageCommissionForm/ManageCommissionForm.tsx";
import { DrawerContent } from "components/UI/DrawerContent/DrawerContent.tsx";
import { FC } from "react";
import { DrawerId, FormId, FormType } from "types/models.ts";

import { Drawer } from "../../UI/Drawer";
import { DrawerTitle } from "../../UI/DrawerTitle/DrawerTitle.tsx";

interface DetailCommissionDrawerProps {
    commissionId: string;
}

export const DetailCommissionDrawer: FC<DetailCommissionDrawerProps> = ({ commissionId }) => {
    const drawerId = DrawerId.DetailCommission;
    const formId = FormId.DetailCommissionForm;

    const getCommissionQuery = useGetCommissionQuery(commissionId, {
        filter: {
            include: "parent",
        },
    });

    if (!getCommissionQuery.data?.commission) {
        return;
    }

    return (
        <Drawer
            drawerId={drawerId}
            title={<DrawerTitle mainTitle={"Affiliate"} subTitles={["Provize", "OfferName"]} />}
            searchParamsToClean={[`${drawerId}-id`]}
        >
            <DrawerContent>
                <ManageCommissionForm
                    commission={getCommissionQuery.data?.commission}
                    formId={formId}
                    formType={FormType.Detail}
                />
            </DrawerContent>
        </Drawer>
    );
};
